import React, { useState, useEffect } from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdFactory } from 'react-icons/md';
import { FaCheckCircle, FaClock } from 'react-icons/fa';

const timelineData = [
  {
    title: "Flour Mill",
    year: "2024–2025",
    description: "Modern flour processing facility.",
    image: "/img/unmakFactory.jpg",
    status: "Completed",
    capacity: "Acme, AB facility 300 tons/day, Linden, AB facility 20 tons/day"
  },
  {
    title: "Pasta Plant",
    year: "2025–2026",
    description: "High capacity pasta production.",
    image: "/img/timeline/pastaPlant.jpg",
    status: "Upcoming",
    capacity: "95 tons/day"
  },
  {
    title: "Confectionary",
    year: "2027–2028",
    description: "Sweets and Treats Factory.",
    image: "/img/timeline/cookie.jpg",
    status: "Upcoming",
    capacity: "68 tons/day"
  },
  {
    title: "Canola Oil",
    year: "2027–2028",
    description: "Cold-pressed canola oil plant.",
    image: "/img/timeline/canolaOil.jpg",
    status: "Upcoming",
    capacity: "200 tons/day"
  },
  {
    title: "Housing & Commercial",
    year: "2025–2030",
    description: "Mixed-use infrastructure project.",
    image: "/img/ivaFactory.jpg",
    status: "Upcoming",
    capacity: "122 residental Units, 160 Apartments"
  },
];

const formatCapacity = (text, isMobile) => {
  return text
    .split(/,(?![^()]*\))/g)
    .map((part, i) => {
      const trimmed = part.trim();
      const dashIndex = trimmed.lastIndexOf(" ");
      const formatted =
        dashIndex !== -1
          ? `${trimmed.slice(0, dashIndex)} - ${trimmed.slice(dashIndex + 1)}`
          : trimmed;

      return (
        <div key={i} style={{ lineHeight: "1.2", fontSize: isMobile ? "1.2rem" : "1.6rem" }}>
          {formatted}
        </div>
      );
    });
};

const VerticalTimelineElementMobile = ({ item, isCompleted, formatCapacity, backgroundColor, textColor, borderColor, iconColor }) => (
  <VerticalTimelineElement
    contentStyle={{
      background: backgroundColor,
      color: textColor,
      border: `3px ${isCompleted ? 'solid' : 'dashed'} ${borderColor}`,
      padding: "0px",
    }}
    contentArrowStyle={{ borderRight: `10px solid ${iconColor}` }}
    iconStyle={{
      background: "#F3F4F6",
      color: "#C38745",
      width: "30px",
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0 0 0 4px #C3874522",
    }}
    icon={<MdFactory size={24} />}
  >

    <div style={{ padding: '10px 0 0 10px' }}>
      <h4 style={{ fontSize: "1.4rem", margin: "0 0 4px" }}>{item.title}</h4>
      <p style={{ fontSize: "1.2rem", margin: 0 }}>{item.description}</p>
    </div>
    <img
      src={item.image}
      alt={item.title}
      loading="lazy"
      style={{
        marginTop: 8,
        width: '100%',
        height: '120px',
        objectFit: 'cover',
      }}
    />

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginTop: "10px",
        gap: "2px",
        flexDirection: "row",
      }}
    >
      {/* Status & Year */}
      <div style={{ flex: 1, padding: '0 0 0 10px' }}>
        {isCompleted ? (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <FaCheckCircle size={16} color="#C38745" />
            <span style={{ fontWeight: "bold", fontSize: "1.2rem", color: "#C38745" }}>
              Completed
            </span>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <FaClock size={16} color="#6B7280" />
            <span style={{ fontWeight: "bold", fontSize: "1.2rem", color: "#6B7280" }}>
              Upcoming
            </span>
          </div>
        )}
        <div style={{ fontSize: "1.2rem", color: "#9CA3AF", marginTop: 4 }}>{item.year}</div>
      </div>

      {/* Capacity */}
      <div style={{ flex: 1, textAlign: "right", padding: '0 10px 0 0' }}>
        <div style={{ fontSize: "0.2rem", color: "#6B7280", fontWeight: "500" }}>
          {formatCapacity(item.capacity)}
        </div>
      </div>
    </div>
  </VerticalTimelineElement>
);

const VerticalTimelineElementDesktop = ({ item, isCompleted, formatCapacity, backgroundColor, textColor, borderColor, iconColor, index }) => (
  <VerticalTimelineElement
    key={index}
    contentStyle={{
      background: backgroundColor,
      color: textColor,
      border: `3px ${isCompleted ? 'solid' : 'dashed'} ${borderColor}`,
      padding: "0",
    }}
    contentArrowStyle={{ borderRight: `14px solid ${iconColor}` }}
    date={
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: index % 2 === 0
            ? "flex-start"
            : "flex-end",
          textAlign: index % 2 === 0
            ? "left"
            : "right",
          fontSize: "1.6rem",
        }}
      >
        {isCompleted ? (
          <>
            <FaCheckCircle
              size={28}
              color="#C38745"
              style={{ marginBottom: 4 }}
            />
            <span
              style={{
                fontWeight: "bold",
                color: "#C38745",
                fontSize: "2rem",
              }}
            >
              Completed
            </span>
          </>
        ) : (
          <>
            <FaClock
              size={28}
              color="#6B7280"
              style={{ marginBottom: 4 }}
            />
            <span
              style={{
                fontWeight: "bold",
                color: "#6B7280",
                fontSize: "1.6rem",
              }}
            >
              Upcoming
            </span>
          </>
        )}
        <span style={{ color: "#9CA3AF", marginTop: 2 }}>{item.year}</span>
        <div
          style={{
            color: "#6B7280",
            fontWeight: "500",
            marginTop: 6,
            fontSize: "1.4rem",
          }}
        >
          {formatCapacity(item.capacity)}
        </div>
      </div>
    }

    iconStyle={{
      background: "#F3F4F6",
      color: "#C38745",
      width: "30px",
      height: "30px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      boxShadow: "0 0 0 4px #C3874522",
    }}
    icon={<MdFactory size={24} />}
  >
    <div style={{ padding: '10px 0 0 10px' }}>
      <h4 style={{ fontSize: "1.4rem", margin: "0 0 4px" }}>{item.title}</h4>
      <p style={{ fontSize: "1.2rem", margin: 0 }}>{item.description}</p>
    </div>
    <img
      src={item.image}
      alt={item.title}
      loading="lazy"
      style={{
        marginTop: 8,
        width: '100%',
        height: '160px',
        objectFit: 'cover'
      }}
    />
  </VerticalTimelineElement>
);


export const Testimonials = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkWidth = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkWidth();
    window.addEventListener('resize', checkWidth);
    return () => window.removeEventListener('resize', checkWidth);
  }, []);

  return (
    <div style={{ padding: '40px 0' }}>
      <div style={{ textAlign: 'center' }}>
        <h2
          style={{
            fontSize: "2.8rem",
            fontWeight: "700",
            marginBottom: "34px",
            color: "#111827",
            position: "relative",
            display: "inline-block",
          }}
        >
          Our Projects Timeline
          <span
            style={{
              position: "absolute",
              width: "50%",
              height: "4px",
              backgroundColor: "#C38745",
              left: 0,
              bottom: -10,
            }}
          ></span>
        </h2>
      </div>

      <div
        style={{
          backgroundColor: 'rgb(249, 250, 251)',
          padding: isMobile ? '0 16px' : '0 160px',
        }}
      >
        <VerticalTimeline>
          {timelineData.map((item, index) => {
            const isCompleted = item.status === "Completed";
            const backgroundColor = isCompleted ? "rgb(248, 241, 231)" : "#FFF";
            const textColor = "#333";
            const borderColor = isCompleted ? "#C38745" : "#D1D5DB";
            const iconColor = isCompleted ? "#C38745" : "#D1D5DB";
            

            return isMobile ? (
              <VerticalTimelineElementMobile
                key={index}
                item={item}
                isCompleted={isCompleted}
                formatCapacity={(text) => formatCapacity(text, isMobile)}
                backgroundColor={backgroundColor}
                textColor={textColor}
                borderColor={borderColor}
                iconColor={iconColor}
              />
            ) : (
              <VerticalTimelineElementDesktop
                key={index}
                item={item}
                isCompleted={isCompleted}
                formatCapacity={(text) => formatCapacity(text, isMobile)}
                backgroundColor={backgroundColor}
                textColor={textColor}
                borderColor={borderColor}
                iconColor={iconColor}
                index={index}
              />
            );
          })}
        </VerticalTimeline>
      </div>
    </div>
  );
};
